<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <div v-show="ui.step === 'acceuil'">
      <p class="ContextBlockSpec">
      <h3><b>Où en est votre défi ?</b></h3> Vous avez relevé le défi de faire 3 vrais repas à table pendant 3 jours, bien répartis au cours de la journée. Il est temps de faire le point.
      </p>

      <p class="ObjectiveBlockSpec">
        <b class="primary--text">Objectif : </b>
        Évaluer ses progrès dans la prise de repas réguliers au quotidien.
      </p>

      <div class="InstructionsBlockSpec">
        Pour réaliser cette mission, vous devez :<br/>
        <ol>
          <li>Répondre au quiz</li>
          <li>VALIDER la mission</li>
        </ol>
      </div>

      <v-btn block
             large
             rounded
             @click="step('question')"
             class="primary mt-10 mb-4">Allons-y !
      </v-btn>
    </div>

    <div v-show="ui.step === 'question'">
      <h3 class="primary--text">Manger régulièrement</h3>
      Le défi consistait à réaliser 3 vrais repas à table par jour (ou collations), bien répartis dans la journée, avec des aliments variés et équilibrés, sans excès.

      <p class="Question">Avez-vous réussi votre défi ?</p>

      <v-btn block
             large
             rounded
             @click="step('oui')"
             class="primary mt-10 mb-4">Oui
      </v-btn>
      <v-btn block
                     large
                     rounded
                     @click="step('non')"
                     class="primary mt-10 mb-4">Non
    </v-btn>
    </div>

    <div v-show="ui.step === 'non'">
      <v-radio-group v-model="missionData.quiz.pourquoi">
        <v-radio :value="0" label="je n’ai pas eu le temps, pas envie de le faire…"></v-radio>
        <v-radio :value="1" label="j’ai eu trop faim"></v-radio>
        <v-radio :value="2" label="trop compliqué à faire, pas possible"></v-radio>
        <v-radio :value="3" label="je n’arrive pas à prendre un petit déjeuner le matin"></v-radio>
        <v-radio :value="4" label="je n’arrive pas à prendre un déjeuner le midi"></v-radio>
        <v-radio :value="5" label="je n’arrive pas à prendre un dîner le soir"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="this.missionData.quiz.pourquoi === null"
             @click="step('commentaire')"
             class="primary mt-10 mb-4">Allons-y !
      </v-btn>
    </div>

    <div v-show="ui.step === 'commentaire'">
      <div class="Info" v-if="missionData.quiz.pourquoi === 0">
        Vous pourrez refaire ce défi une autre fois ou en choisir un autre, n’abandonnez pas !
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 1">
        Si vous avez faim entre les repas, n’oubliez pas que vous pouvez prévoir de petites collations entre les repas : fruit, fruits secs, petit sandwich…
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 2">
        N’oubliez pas que vous pouvez organiser vos repas sans pour autant respecter les horaires classiques, à vous d’adapter comme cela vous convient le mieux.
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 3">
        Ce n’est pas une obligation, prévoyez une collation à la place un peu plus tard dans la matinée.
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 4">
        Ce n’est pas une obligation, prévoyez une collation à la place un peu plus tard dans l’après midi.
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 5">
        Ce n’est pas une obligation, prévoyez une collation à la place en fin d’après midi, pour éviter la fringale avant de dormir.
      </div>

      <v-btn block
             large
             rounded
             @click="step('fin')"
             class="primary mt-10 mb-4">Fin
      </v-btn>
    </div>

    <div v-show="ui.step === 'oui'">
      <div class="Info">
        <p>Bravo ! Vous avez relevé le défi avec succès.</p>
        <p>Vous avez déjà dû vous rendre compte que cette bonne répartition des repas évite la faim et conduit à manger mieux et en moins grandes quantités. Maintenant que vous en avez fait l’expérience, adoptez ce rythme de repas et continuez votre défi au quotidien, et profitez de ses bénéfices sur votre santé !</p>
      </div>

      <v-btn block
             large
             rounded
             @click="step('fin')"
             class="primary mt-10 mb-4">Fin
      </v-btn>
    </div>

    <div v-show="ui.step === 'fin'">
      <div class="Info">
        Merci d'avoir répondu à ce questionnaire.<br/>
        Vous pourrez retrouver l'analyse de vos réponses dans votre médiathèque.
      </div>

      <p class="primary--text" style="font-size: 15px; font-style: italic">Appuyer sur « Valider la mission » pour valider et enregistrer ce questionnaire</p>

      <FinishMissionButtonBlock class="mt-10"
                                @click.native="finishMission">Valider la mission
      </FinishMissionButtonBlock>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'

  export default {
    components: {
      FinishMissionButtonBlock,
      MissionContainer
    },
    data () {
      return {
        missionData: {
          quiz: {
            question: null,
            pourquoi: null
          }
        },
        ui: {
          step: 'acceuil'
        }
      }
    },

    methods: {
      finishMission () {
        this.ui.loading = true
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      },

      step (target) {
        this.updateData(target);
        this.ui.step = target;
      },

      updateData(target) {
        switch (target) {
          case 'oui':
            this.missionData.quiz.question = true;
            break;
          case 'non':
            this.missionData.quiz.question = false;
        }
      }
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Question {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
